module.exports = __webpack_public_path__ + "img/volvo_thumbnail.2a6fe347.png";